import SalesContainer from './sales-container';

export default SalesContainer;
